import React from "react";
import Preloader from "../../helper/Preloader";
import HeaderOne from "../../components/HeaderOne";
import BottomFooter from "../../components/BottomFooter";
import ResetPassword from "../../components/ResetPassword";
import ScrollToTop from "react-scroll-to-top";
import ColorInit from "../../helper/ColorInit";
import FooterOne from "../../components/FooterOne";


const ForgotPasswordPage = () => {



  return (
    <>
      {/* ColorInit */}
      <ColorInit color={true} />

      {/* ScrollToTop */}
      {/* <ScrollToTop smooth color="#1E293B" /> */}

      {/* Preloader */}
      <Preloader />

      {/* HeaderTwo */}
      <HeaderOne />

      {/* ResetPassword */}
      <ResetPassword />

      {/* FooterTwo */}
      <FooterOne />

      {/* BottomFooter */}
      {/* <BottomFooter /> */}


    </>
  );
};

export default ForgotPasswordPage;